<template>
    <b-overlay :show="showoverlay" rounded="sm">
    <div>
        
        <div class="row no-margin">
            <div class="col-md-4">
                <h4 class="atlhr-dashboard-title mt-10">Employee Management<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Employee Management</span></h4>
            </div>
            <div class="col-md-8 pr-0">
                <div v-if="employee_id > 0">
                    <employee-previous-next ></employee-previous-next>
                </div>
            </div>
        </div>
        
        
        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
        <b-alert show dismissible fade v-if='warningmsg' variant='warning'>{{warningmsg}}</b-alert>
        <b-alert show dismissible fade v-if='dangermsg' variant='danger'>{{dangermsg}}</b-alert>
        <div  class="clearfix row no-gutters employee-profile" v-if="employee_id > 0">            
            <employee-public-info :key="c_flg"></employee-public-info>
        </div>
        <div class="employee-tab" :class="{'new-employee-container' : employee_id == 0}">
            <b-tabs v-model="ewtabIndex" pills content-class="" nav-class="pr-2 m-2" nav-wrapper-class="col-md-9 card no-shadow custom-margin custom-tab-nav ml-auto pl-0">
                                
                <template>
                    <b-tab >
                        <template active v-slot:title>
                            <b-icon icon="arrow-right-circle" variant="info" animation="fade" class="pr-1" v-b-tooltip.hover title="Has Draft Data" v-if="draft_flg == 1"></b-icon>
                            Profile
                        </template>
                        <div class="clearfix">
                            <div class="">
                                <account-employees :flg="1" v-on:childToParent="getAccountEmployees"></account-employees>
                            </div>
                        </div>
                    </b-tab>
                    
                    <template v-if="this.$acl['contract/update'] > 0">                    
                        <b-tab lazy v-if="employee_id > 0">
                            <template active v-slot:title>
                                <b-icon icon="arrow-right-circle" variant="info" animation="fade" class="pr-1" v-b-tooltip.hover title="Has Draft Data" v-if="draft_contract == 1"></b-icon>
                                Contracts
                            </template>
                            <div class="clearfix">
                                <div class="">
                                    <contract-form @event="contractChanged"></contract-form>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab disabled v-else>
                            <template  v-slot:title>Contracts</template>                
                            <div class="clearfix">
                                <div class="">
                                    &nbsp;
                                </div>
                            </div>
                        </b-tab>
                    </template>

                    <template v-if="employee_residency != 'Resident Expatriate'">
                        <template v-if="this.$acl['employee/investment'] > 0">   
                            <b-tab lazy v-if="employee_id > 0">
                                <template active v-slot:title>Investments</template>                
                                <div class="clearfix">
                                    <div class="">
                                        <employee-investment-info :flg="1"></employee-investment-info>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab disabled v-else>
                                <template  v-slot:title>Investments</template>                
                                <div class="clearfix">
                                    <div class="">
                                        &nbsp;
                                    </div>
                                </div>
                            </b-tab>
                        </template>
                    </template>

                    <template v-if="this.$acl['employee/ait'] > 0">
                        <b-tab lazy v-if="employee_id > 0">
                            <template active v-slot:title>AIT</template>                
                            <div class="clearfix">
                                <div class="">
                                    <employee-ait-info :flg="1"></employee-ait-info>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab disabled v-else>
                            <template  v-slot:title>AIT</template>                
                            <div class="clearfix">
                                <div class="">
                                    &nbsp;
                                </div>
                            </div>
                        </b-tab>
                    </template>



                    <template v-if="this.$acl['employee/tax_cards'] > 0">
                        <b-tab lazy v-if="employee_id > 0">
                            <template active v-slot:title>Tax Cards</template>                
                            <div class="clearfix">
                                <div class="">                            
                                    <tax-cards ></tax-cards>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab disabled v-else>
                            <template  v-slot:title>Tax Cards</template>                
                            <div class="clearfix">
                                <div class="">
                                    &nbsp;
                                </div>
                            </div>
                        </b-tab>
                    </template>
                    
                    <template v-if="this.$acl['employee/payslips'] > 0">
                        <b-tab lazy v-if="employee_id > 0">
                            <template active v-slot:title>Pay Slips</template>                
                            <div class="clearfix">
                                <div class="">                            
                                    <employeepayslips ></employeepayslips>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab disabled v-else>
                            <template  v-slot:title>Pay Slips</template>                
                            <div class="clearfix">
                                <div class="">
                                    &nbsp;
                                </div>
                            </div>
                        </b-tab>
                    </template>
                   
                    <template v-if="this.$acl['employee/pf'] > 0">
                        <template v-if="addons.includes('Pf')">
                             <b-tab lazy v-if="employee_id > 0 && is_enrollment_date"> <!-- Rejwan: 29-01-2025 -->
                                <template active v-slot:title>Provident Fund Summery</template>                
                                <div class="clearfix">
                                    <div class="">                            
                                        <employee-pf-summery :pageurl="this.pageUrl"></employee-pf-summery>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab disabled v-else>
                                <template  v-slot:title>Provident Fund Summery</template>                
                                <div class="clearfix">
                                    <div class="">
                                        &nbsp;
                                    </div>
                                </div>
                            </b-tab> 
                            <!-- <b-tab lazy v-if="employee_id > 0"> -->
                            <b-tab lazy v-if="employee_id > 0 && is_enrollment_date"> <!-- Rejwan: 29-01-2025 -->
                                <template active v-slot:title>Provident Fund Statement</template>                
                                <div class="clearfix">
                                    <div class="">                            
                                        <employee-pf-statement :pageurl="this.pageUrl"></employee-pf-statement>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab disabled v-else>
                                <template  v-slot:title>Provident Fund Statement</template>                
                                <div class="clearfix">
                                    <div class="">
                                        &nbsp;
                                    </div>
                                </div>
                            </b-tab> 
                            <!-- <b-tab lazy v-if="employee_id > 0"> -->
                            <b-tab lazy v-if="employee_id > 0 && is_enrollment_date"> <!-- Rejwan: 29-01-2025 -->
                                <template active v-slot:title>Provident Fund Schedule</template> 
                                            
                                <div class="clearfix">
                                    <div class="">                            
                                        <pf-contributions :pageurl="this.pageUrl"></pf-contributions>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab disabled v-else>
                                <template  v-slot:title>Provident Fund Schedule</template>                
                                <div class="clearfix">
                                    <div class="">
                                        &nbsp;
                                    </div>
                                </div>
                            </b-tab>
                            <!-- <b-tab lazy v-if="employee_id > 0"> -->
                            <b-tab lazy v-if="employee_id > 0 && is_enrollment_date"> <!-- Rejwan: 29-01-2025 -->
                                <template active v-slot:title>Provident Fund Loan</template>                
                                <div class="clearfix">
                                    <div class="">                            
                                        <pf-employee-loan-list :pageurl="this.pageUrl" :employee_id="employee_id" :flg="1"></pf-employee-loan-list>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab disabled v-else>
                                <template  v-slot:title>Provident Fund Loan</template>                
                                <div class="clearfix">
                                    <div class="">
                                        &nbsp;
                                    </div>
                                </div>
                            </b-tab>

                            <!-- <b-tab lazy v-if="employee_id > 0"> -->
                            <b-tab lazy v-if="employee_id > 0 && is_enrollment_date"> <!-- Rejwan: 29-01-2025 -->
                                <template active v-slot:title>Migrated PF History</template>                
                                <div class="clearfix">
                                    <div class="">                            
                                        <employee-mpf-info :pageurl="this.pageUrl" :flg="1"></employee-mpf-info>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab disabled v-else>
                                <template  v-slot:title>Migrated PF History</template>                
                                <div class="clearfix">
                                    <div class="">
                                        &nbsp;
                                    </div>
                                </div>
                            </b-tab>

                        </template>
                    </template>


                    <template v-if="this.$acl['employee/rfa'] > 0">
                        <b-tab lazy v-if="employee_id > 0">
                            <template active v-slot:title>Rent Free Accommodation</template>                
                            <div class="clearfix">
                                <div class="">                            
                                    <employee-rfc-info :flg="1"></employee-rfc-info>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab disabled v-else>
                            <template  v-slot:title>Rent Free Accommodation</template>                
                            <div class="clearfix">
                                <div class="">
                                    &nbsp;
                                </div>
                            </div>
                        </b-tab>
                    </template>


                    <template v-if="this.$acl['employee/mph'] > 0">
                        <b-tab lazy v-if="employee_id > 0">
                            <template active v-slot:title>
                                <b-icon icon="arrow-right-circle" variant="info" animation="fade" class="pr-1" v-b-tooltip.hover title="Has Draft Data" v-if="draft_mph == 1"></b-icon>
                                Migrated Payroll History
                            </template>
                            <div class="clearfix">
                                <div class="">                            
                                    <employee-mph-info :flg="1"></employee-mph-info>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab disabled v-else>
                            <template  v-slot:title>Migrated Payroll History</template>                
                            <div class="clearfix">
                                <div class="">
                                    &nbsp;
                                </div>
                            </div>
                        </b-tab>
                    </template>


                    <!-- <template v-if="this.$acl['employee/mpfh'] > 0">
                        <template v-if="addons.includes('Pf')">
                            <b-tab lazy v-if="employee_id > 0">
                                <template active v-slot:title>
                                    <b-icon icon="arrow-right-circle" variant="info" animation="fade" class="pr-1" v-b-tooltip.hover title="Has Draft Data" v-if="draft_mpfh == 1"></b-icon>
                                    Migrated PF History
                                </template>
                                <div class="clearfix">
                                    <div class="">                            
                                        <employee-mpf-info :flg="1"></employee-mpf-info>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab disabled v-else>
                                <template  v-slot:title>Migrated PF History</template>                
                                <div class="clearfix">
                                    <div class="">
                                        &nbsp;
                                    </div>
                                </div>
                            </b-tab>
                        </template>
                    </template> -->


                    
                    <b-tab lazy v-if="employee_id > 0">
                        <template active v-slot:title>Loan / Advance</template>  
                        
                        <template  v-if="$acl['loan-advance/applications'] > 0"> 
                            <div class="clearfix">
                                <div class="">                            
                                    <employee-loan-list :flg="1"  :employee_id="employee_id" :bn="this.public_info.name" ></employee-loan-list>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <lock-template ></lock-template>
                        </template>
                                     
                        
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Loan / Advance</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>



                    <b-tab lazy v-if="employee_id > 0">
                        <template active v-slot:title>Documents</template>                
                        <div class="clearfix">
                            <div class="">                            
                                <employee-documents :flg="this.permission"></employee-documents>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Document</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>


                    <template v-if="addons.includes('LeaveAttendances')">
                        <b-tab lazy v-if="employee_id > 0">
                            <template active v-slot:title>Leave Attendance</template>                
                            <div class="clearfix">
                                <div class="">                            
                                    <employee-leave-attendance-wrapper :is_profile="true"></employee-leave-attendance-wrapper>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab disabled v-else>
                            <template  v-slot:title>Leave Attendance</template>                
                            <div class="clearfix">
                                <div class="">
                                    &nbsp;
                                </div>
                            </div>
                        </b-tab>
                    </template>
                    
                    <!--Jarir 16 February 2026-->
                    <!-- Service Book Tab , Service Book Link Added, uses Session and Employee ID from JS functions-->
                    <b-tab lazy v-if="employee_id > 0" @click="syncSession">
                        <template active v-slot:title>Service Book</template>                
                        <div class="clearfix">
                             <service-book-service-book-dashboard :is-embedded="true"></service-book-service-book-dashboard>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Service Book</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>
                    <!-- End: Service Book Tab -->

                </template>
                
            </b-tabs>
        </div>
        <b-modal id="bv-modal-employeesearch" size="lg" hide-footer title="Search Employees">
            <keep-alive>
                <search-employees></search-employees>
            </keep-alive>
        </b-modal>
    </div>
    </b-overlay>
</template>
<script>
       
    export default{
        mounted() {
            this.setTabIndex();
            //this.showoverlay = false;  
            setTimeout(this.showContent , 3000);    
            
        },
        props: ['readonly', 'employee_id'],
        components: {
            
        },
        data(){            
            
            return {
                showoverlay : true,
                cu:window.location.href,
                ce : false,
                avatarsrc : null,
                employee_id : this.$props.employee_id || 0,
                company_id : 0,
                ewtabIndex : 0,
                employee_exists : 'employee-exists',
                public_info : [{name:'', email:'', jobposition:'', department:'', company:'', join_date:'', contract_expire:''}],
                
                isHovered: false,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,

                c_flg: 0, // This variable is for reloading public info

                draft_flg: 0,
                draft_mph: 0,
                draft_mpfh: 0,
                draft_contract: 0,
                employee_residency : '',
                addons:[],
                is_enrollment_date: false, // Rejwan: 29-01-2025

            }
        },
        methods:{
            
            showContent: function()
            {
                this.showoverlay = false;
            },
             
            showSerch: function(){
                this.$bvModal.show('bv-modal-employeesearch');
            },
            getEmployeeData: function(){
                if(!this.checkNet()) return false;
                
                this.c_flg += 1;                
            },                        
            handleHover(hovered) {
                
                this.isHovered = hovered
            },
            getAccountEmployees (value) 
            {
                this.employee_id = value.employee_id;
                if(this.employee_id > 0)
                {
                    this.getEmployeeData();
                    
                    this.draft_flg = value.draft_flg;
                    this.draft_mph = value.draft_mph;
                    this.draft_mpfh = value.draft_mpfh;
                    this.draft_contract = value.draft_contract;
                }                   

            },
            getContractForm (value) 
            {
                this.public_info.contract_expire = value.contract_expire;
            },
            contractChanged(value){
               if(value=='removed' || value=='added'){
                  this.c_flg += 1;
               }
            },
            setTabIndex:function(event)
            {
                if(!this.checkNet()) return false;
                // Updated by Jarir 2026-04-20 — Converted GET→POST for security; Priority to ServiceBook module getid
                let getidUrl = this.$api_url + '/admin-service-book/getid';
                axios.post(getidUrl)
                    .catch(() => axios.get(this.$api_url + '/employee/getid'))
                    .then(function (response) {

                        if(this.ce == false)
                        {
                            this.ewtabIndex = 0;
                            return;
                        }
                        
                        this.employee_id = response.data;
                        
                            let uri = window.location.href.split('?');
                            if (uri.length == 2)
                            {
                                let vars = uri[1].split('&');
                                let getVars = {};
                                let tmp = '';
                                vars.forEach(function(v){
                                    tmp = v.split('=');
                                    if(tmp.length == 2)
                                        getVars[tmp[0]] = tmp[1];
                                });
                                //console.log(getVars['#']);
                                if(getVars['#'])
                                    this.ewtabIndex = parseInt(getVars['#']);
                                
                            }                       
                                            

                    }.bind(this));                

            },

            getEmployeeResidency:function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/getresidency')
                    .then(function (response) {                         
                        this.employee_residency = response.data;
                    }.bind(this));
            }
            ,
            getCompanyAddOns:function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/get-addons')
                    .then(function (response) {                         
                        this.addons = response.data;
                    }.bind(this));
            },
             // Start: Rejwan: 29-01-2025
            getEmployeePFEnrollmentDate() {
                axios.get(this.$api_url+'/pf/employee/pf-enrollment-date', {
                }).then(function (response) {
                    if(response.data.success == true) {
                        this.is_enrollment_date = true;
                    }
                }.bind(this)).catch(function (error){alert(error)});
               
            },
            // End: Rejwan: 29-01-2025

            syncSession() {
                axios.post(this.$api_url + '/employee/setemployee', {
                    employee_id: this.employee_id
                });
            }
        },
        created: function(){
            //
            //this.getAcl();
            this.getEmployeeData();
            this.getEmployeeResidency();
            this.getCompanyAddOns();
            this.getEmployeePFEnrollmentDate(); // Rejwan: 29-01-2025  
            //this.setTabIndex();
        }

    }

</script>
